import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

//Third_party_Module
import {TranslateModule} from 'ng2-translate';
//for pagination kauhsalya(2017-08-04)
import {NgxPaginationModule} from 'ngx-pagination';
//Define Module
import { DashboardModule } from "./dashboard/dashboard.module";
import { WorkModule } from "./work/work.module";
import { IssuesModule } from "./issues/issues.module";
import { TestCasesModule } from "./test-cases/test-cases.module";
import { TimeModule } from "./time/time.module";
import { LeaveModule } from "./leave/leave.module";
import { ReportsModule } from "./reports/reports.module";

import { PipeCapitalizeModule } from '../shared/modules/pipe-capitalize/pipe-capitalize.module';
import { ModalLoginAgainModule } from '../shared/modules/modal-login-again/modal-login-again.module';
import { DevelopmentModule } from '../shared/modules/development/development.module';
//Components
import { MainComponent } from './main.component';
//Route
import { mainRouting,  mainRoutingProviders } from './main.routes';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,

    DashboardModule,
    WorkModule,
    IssuesModule,
    TestCasesModule,
    TimeModule,
    LeaveModule,
    
    ReportsModule,

    TranslateModule,
    PipeCapitalizeModule,
    ModalLoginAgainModule,
    DevelopmentModule,
    mainRouting,
    NgxPaginationModule
  ],
  declarations: [
    MainComponent,
  ],
  providers: [
    mainRoutingProviders
  ]
})
export class MainModule { }



// WEBPACK FOOTER //
// ./src/app/modules/main.module.ts